import React, { Component } from 'react';
import { Route } from 'react-router';
import { Col, Grid, Row, Button } from 'react-bootstrap';
import MenuPrincipal from './MenuPrincipal';
import MenuFinal from './MenuFinal';
import PopUp from './PopUp';

import { LinkContainer } from 'react-router-bootstrap';
import '../css/Global.css';
import InformesJPG from '../Images/Informes.jpg';

export class Informes extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            Carrera: this.props.solicitarCarrera(),
            InfNombre: "",
            InfCorreo: "",
            InfTel: "",
            InfComentarios:""
        }
        this.cambioCarrera = this.cambioCarrera.bind(this);
        this.cambioNombre = this.cambioNombre.bind(this);
        this.cambioCorreo = this.cambioCorreo.bind(this);
        this.cambioTel = this.cambioTel.bind(this);
        this.cambioComentarios = this.cambioComentarios.bind(this);
        this.validar = this.validar.bind(this);
        this.mostrarPopup = React.createRef();
    }


    cambioCarrera(event) {
        var valor = event.target.value;
        this.setState({ Carrera: valor });
    }

    cambioNombre(event) {
        var valor = event.target.value;
        this.setState({ InfNombre: valor });
    }

    cambioCorreo(event) {
        var valor = event.target.value;
        this.setState({ InfCorreo: valor });
    }

    cambioTel(event) {
        var valor = event.target.value;
        this.setState({ InfTel: valor });
    }

    cambioComentarios(event) {
        var valor = event.target.value;
        this.setState({ InfComentarios: valor });
    }

    validar() {
        var faltantes = [];
        if (this.state.InfNombre === "") {
            faltantes.push("Nombre");
        }

        if (this.state.InfCorreo === "") {
            faltantes.push("Correo electrónico");
        }

        if (this.state.InfTel === "") {
            faltantes.push("Teléfono");
        }

        if (faltantes.length === 0) {
            var sobre = {
                Nombre: this.state.InfNombre,
                Email: this.state.InfCorreo,
                Telefono: this.state.InfTel,
                Comentario: this.state.InfComentarios,
                Carrera: this.state.Carrera,
                GUID: this.props.getGuid()
            }
            var xhr = new XMLHttpRequest();
            var principal = this;

            xhr.open("POST", "api/Web/Informes", true);

            xhr.setRequestHeader("Content-Type", "application/json");

            xhr.onload = function () {
                if (xhr.status === 200) {
                    if (xhr.responseText == "true") {
                        principal.mostrarPopup.current.mostrar(3, faltantes);
                        principal.limpiar();
                    } else {
                        principal.mostrarPopup.current.mostrar(4, faltantes);
                    }
                } else {
                    principal.mostrarPopup.current.mostrar(4, faltantes);
                };

            };

            xhr.send(JSON.stringify(sobre));
            this.mostrarPopup.current.mostrar(2);
        } else {

            this.mostrarPopup.current.mostrar(1,faltantes);
        }



    }



    limpiar() {
        this.setState({ InfNombre: "", InfCorreo: "", InfTel: "", InfComentarios: "" });
    }

    render() {
        return (
            <div className="FondoAlterno">
                <div className="Separador ListaTabla DosColumnas FondoAlterno ">
                    <ul>
                        <li>
                            <div className="CentrarH">
                        <h2 className="CentrarH"><strong>Solicitar m&aacute;s Informaci&oacute;n</strong></h2>
                        <br/>
                        <br />
                                <table className="Parrafo1 InputsLargo UnaColumna" >
                                    <tbody>
                            <tr>
                                <td>
                                    <p>Nombre</p>
                                </td>
                                        <td>
                                            <input value={this.state.InfNombre} onChange={this.cambioNombre}  />
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <p>Correro electr&oacute;nico</p>
                                </td>
                                        <td>
                                            <input type="email" value={this.state.InfCorreo} onChange={this.cambioCorreo} />
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <p>Tel&eacute;fono</p>
                                </td>
                                        <td>
                                            <input type="tel" value={this.state.InfTel} onChange={this.cambioTel} />
                                        </td>

                                        
                                    </tr>
                                    <tr>
                                        <td>
                                            <p>Programa acad&eacute;mico</p>
                                        </td>
                                        <td>
                                            <select value={this.state.Carrera} onChange={this.cambioCarrera} className="Fuente3" style={{ fontSize: "11pt" }}>
                                                <option value='DIA'>Doctorado en Educaci&oacute;n Especial</option>
                                                <option value='DEAA'>Doctorado en Educaci&oacute;n y Amb. de Apren. Digital</option>
                                                <option value='DCEN'>Doctorado en Pedagog&iacute;a</option>
                                                <option value='MEDN'>Maestr&iacute;a en Educaci&oacute;n Especial</option>
                                                <option value='MCSN'>Maestr&iacute;a en Sociolog&iacute;a Educativa</option>
                                                <option value='MENT'>Maestr&iacute;a en Educaci&oacute;n y Nuevas Tecnolog&iacute;as</option>
                                                <option value="MCEN">Maestr&iacute;a en Educaci&oacute;n Nutricional</option>
                                                <option value="MAPL">Maestr&iacute;a en Administraci&oacute;n P&uacute;blica</option>
                                                <option value="ENT">Especialidad en Educaci&oacute;n y Nuevas Tecnolog&iacute;as</option>
                                                <option value="ECE">Especialidad en Calidad Educativa</option>
                                                <option value="IRO">Ing. en Rob&oacute;tica</option>
                                                <option value="ICA">Ing. en Control y Automatizaci&oacute;n</option>
                                                <option value="LPS">Lic. en Psicolog&iacute;a Social</option>
                                                <option value="LSE">Lic. en Sociolog&iacute;a de la Educaci&oacute;n</option>
                                                <option value="LSP">Lic. en Sociolog&iacute;a Politica</option>
                                                <option value="LFL">Lic. en Filolog&iacute;a y Literatura</option>
                                                <option value="LCPL">Lic. Contadur&iacute;a P&uacute;blica</option>
                                                <option value="LAEL">Lic. Administraci&oacute;n de Empresas</option>
                                                <option value="LEC">Lic. Econom&iacute;a</option>
                                                <option value="TDAH">Dipl. en Inclusi&oacute;n de niños con TDAH</option>
                                                <option value="AUTI">Dipl. en Inclusi&oacute;n de niños con Autismo</option>
                                                <option value="GOOG">Dipl. Uso did&aacute;ctico en el aula de las aplic. de Google</option>
                                                    <option value="EAD">Dipl. Formaci&oacute;n de Profesores para el diseño e implementaci&oacute;n de Cursos en l&iacute;nea</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p>Comentarios</p>
                                        </td>
                                        <td>
                                            <textarea rows="3" value={this.state.InfComentarios} onChange={this.cambioComentarios} />
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <div style={{ paddingTop: "40px" }}>
                                    <input value="Enviar" type="button" style={{ paddingLeft: "35px", paddingRight: "35px", paddingBottom: "5px", paddingTop: "5px", marginBottom: "55px" }} onClick={this.validar} />
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="Parrafo1 CentrarH">
                        <img className="Circular2" src={InformesJPG} alt='Inscribirse' />

                                <p style={{ width: "auto", margin: "auto", padding: "20px" }}>
                                    Si ya estas listo, realiza tu proceso de inscripci&oacute;n en l&iacute;nea
                                </p>
                                <br />

                                <input value='Inscribete aquí' type='button' onClick={ () => { window.open("/Pagos/Diplomados") }} />
                                <p style={{ width: "auto", margin: "auto", padding: "20px" }}>
                                    Fecha limite de inscripci&oacute;n <span>{this.props.fechaLimite()}</span>
                                    <br/>
                                    <strong>Inicio de cursos <span>{this.props.fechaInicio()}</span>.</strong>
                                    </p> 
                                 
                                 
                            </div>
                        </li>
                    </ul>
                </div>
                <PopUp ref={this.mostrarPopup} />

            </div>
            )
    }
}
export default Informes;


// WEBPACK FOOTER //
// ./src/components/Informes.js